import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
import { ReactComponent as CrossIcon } from "../../assets/svg/close.svg";
import { Row, Col } from "react-bootstrap";
// import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from "dompurify";
// import { createPOVApi, getLocationListApi, getPOVDetailsApi, updatePOVApi } from "./setup-api";
import AsyncSelect from "react-select/async";
// import "../masters/customers/customer.css";
import SearchWithAPI from "../searchbox/searchbox.js";
import img from "../../assets/svg/img.svg";
import upload from "../../assets/svg/upload.svg";
import close from "../../assets/svg/close.svg";
import { getInternalWidgetsApi } from "./device-group-api";

const AddApplicationModal = ({ type, application, onSuccess, errorMsg, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [validations, setValidations] = useState({
    name: "",
    application: "",
    icon: "",
  });
  const [name, setName] = useState("");
  const [base64File, setBase64File] = useState(null);
  const [urlImage, setUrlImage] = useState(null);
  const [removedImageList, setRemovedImageList] = useState([]);

  const [selectedApplication, setSelectedApplication] = useState({
    id: "",
    application_id: "",
    application_name: "",
    name: "",
    icon_name: "",
    icon: "",
    selected_status: true,
    type: type,
    data_flow: "",
    duration_time: "",
    interval_time: "",
    sequence_order: "",
    widget_type: type === "Internal" ? "Widget" : "Embedded",
    embedded_link: "",
    internal_widgets: [],
  });

  useEffect(() => {
    if (application != null) {
      console.log(application);
      setSelectedApplication(application);
      setName(application.name);

      if (type === "External") {
        setBase64File(application.icon);
      }
      if (type === "Internal") {
        setApplicationOption({
          value: application.application_id ?? "",
          label: application.application_name ?? "",
        });
      }
    }
  }, [application]);

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "470px",
      overflow: "visible",
      minHeight: "fit-content",
    },
  };

  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        setBase64File(base64String);
        const tempApp = { ...selectedApplication };
        tempApp["icon"] = base64String;
        setSelectedApplication(tempApp);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid image file.");
    }
  };

  const [applicationOption, setApplicationOption] = useState(null);
  const handleApplicationDropdownChange = (option) => {
    console.log(option);
    setApplicationOption(option);
    /* const tempApp = { ...selectedApplication };
    tempApp["application_id"] = option.value;
    tempApp["application_name"] = option.label;
    setSelectedApplication(tempApp); */
    getInternalWidgets(option);
  };
  const getInternalWidgets = async (option) => {
    try {
      const response = await getInternalWidgetsApi(option.value);
      if (response.data.success === true) {
        const tempApp = { ...selectedApplication };
        tempApp["application_id"] = option.value;
        tempApp["application_name"] = option.label;
        tempApp["internal_widgets"] = response.data.suggestionlist.map((item, i) => ({
          seq_no: i + 1,
          widget_id: item.value,
          name: item.label,
          status: true,
        }));

        console.log(tempApp);
        setSelectedApplication(tempApp);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff", maxHeight: "90vh", overflowY: "auto" }}>
          <div className="mx-3 mt-1 style-justify-between">
            <div>
              <div className="add-item-modal-title">{selectedApplication != null ? "Edit " : "Add "} application</div>
              <div className="font-13-400-66737E">Enter given below details to create a new external application</div>
            </div>
            <ModalCloseIcon style={{ cursor: "pointer" }} onClick={onCancel} />
          </div>
          <div style={{ padding: "16px 24px" }}>
            <Row>
              <Col xs={12} sm={12} className="mt-2 px-0 ps-md-1">
                <div className="field-title mb-2">
                  Name<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field w-100"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    const tempApp = { ...selectedApplication };
                    tempApp["name"] = e.target.value;
                    setSelectedApplication(tempApp);
                  }}
                />
                <span className="field-error">{validations.name}</span>
                <span className="field-error">{errorMsg}</span>
              </Col>
              {type === "Internal" && (
                <Col xs={12} sm={12} className="mt-2 px-0 ps-md-1">
                  <div className="field-title mb-2">
                    Application<span style={{ color: "#FF4444" }}>*</span>{" "}
                  </div>
                  <SearchWithAPI onDropdownChange={handleApplicationDropdownChange} apiUrl={apiUrl + "get_internal_applications"} params={{}} placeholder={"Select application"} selectedOption={applicationOption} />
                  <span className="field-error">{validations.application}</span>
                </Col>
              )}
              {type === "External" && (
                <Col xs={12} sm={12} className="mt-2 px-0 ps-md-1">
                  <div className="field-title mb-2">
                    Upload logo<span style={{ color: "#FF4444" }}>*</span>{" "}
                  </div>
                  <div
                    style={{
                      borderRadius: "12px",
                      padding: "20px",
                      textAlign: "center",
                      marginBottom: "20px",
                      backgroundColor: "#F9F9F9",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <img src={img} alt="Upload icon" style={{ width: "40px", marginBottom: "10px" }} />
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#888",
                      }}
                    >
                      Upload logo
                    </div>
                    <div className="style-justify-center gap-2">
                      <button
                        onClick={handleFileClick}
                        style={{
                          marginTop: "10px",
                          color: "#d33",
                          border: "1px solid #E5E5E5",
                          padding: "10px 16px 10px 16px",
                          borderRadius: "37px",
                          background: "#FFFFFF",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontSize: "13px",
                          fontFamily: "epilogue",
                          fontWeight: "500",
                        }}
                      >
                        <img src={upload} alt="Upload icon" style={{ width: "16px", height: "16px" }} />
                        Upload
                      </button>
                    </div>
                  </div>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    onChange={handleFileChange}
                    style={{ display: "none" }} // Hide the actual file input
                  />
                  <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
                    {urlImage != null && urlImage !== "" && (
                      <div key={"url-image-"} className="mt-3" style={{ position: "relative" }}>
                        <img
                          src={urlImage != null && urlImage !== "" ? urlImage.image : ""}
                          alt="complaint"
                          style={{
                            width: "72px",
                            height: "72px",
                            borderRadius: "14px",
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "1px",
                            right: "1px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={close}
                              alt=""
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setUrlImage(null);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {base64File != null && base64File !== "" && (
                      <div key={"base-image-"} className="mt-3" style={{ position: "relative" }}>
                        <img
                          src={base64File != null && base64File !== "" ? base64File : ""}
                          alt="complaint"
                          style={{
                            width: "72px",
                            height: "72px",
                            borderRadius: "14px",
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: "1px",
                            right: "1px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={close}
                              alt=""
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setBase64File(null);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <span className="field-error">{validations.icon}</span>
                </Col>
              )}
              <Col xs={12} sm={12} className="mt-2 px-0 ps-md-1">
                <div className="style-justify-end">
                  <div onClick={onCancel} className="cancel-modal-btn style-justify-center">
                    Cancel
                  </div>
                  <div
                    className="save-modal-btn style-justify-center"
                    onClick={() => {
                      const tempValidate = { ...validations };
                      if (name !== "" && (type === "Internal" || (type === "External" && (base64File != null || urlImage != null))) && (type === "External" || (type === "Internal" && applicationOption != null))) {
                        onSuccess(selectedApplication);
                      } else {
                        if (name === "") {
                          tempValidate.name = "Name required!";
                        } else {
                          tempValidate.name = "";
                        }
                        if (type === "Internal" && applicationOption === null) {
                          tempValidate.application = "Application required!";
                        } else {
                          tempValidate.application = "";
                        }

                        if (base64File === null) {
                          tempValidate.icon = "Icon required!";
                        } else {
                          tempValidate.icon = "";
                        }
                        setValidations(tempValidate);
                      }
                    }}
                  >
                    {application != null ? "Update " : "Save "}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddApplicationModal;
